import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter/index';
import {useDispatch} from 'react-redux';
import {getFormattedText} from 'src/components/analytics/discover/common';
import {PRODUCT_LISTS, routeToProduct} from 'src/utils/referrer-portal';

import {getAllowedAgency} from 'src/action-creators/referrer-portal/authentication';
import {
  SideMenuLink,
  Button,
} from '@spaced-out/ui-design-system/lib/components/index';
import SetupProfile from 'src/components/referrer-portal/settings/profile/setup-profile';
import {AccountBar} from 'src/components/referrer-portal/side-nav/account-bar';
import SenseLogo from 'src/images/sense-new-logo.svg';
import styles from 'src/components/app.css';
import css from 'src/components/referrer-portal/side-nav/side.css';


const SideNav = ({children}: {children: React.ReactNode}) => {
  const {t, makeKey} = useLabelTranslation();
  const dispatch = useDispatch();
  const router = useHistory();
  const defaultSelecttab = PRODUCT_LISTS.find((productList) =>
    router.location.pathname.includes(productList.product),
  )?.product;

  const [selectedProduct, setSelectedProduct] = React.useState(
    defaultSelecttab ?? PRODUCT_LISTS[0].product,
  );

  const [profileUrl, setProfileUrl] = React.useState<any>(null);

  const handleOnChange = (
    e: React.SyntheticEvent<HTMLElement>,
    selectedKey: string,
  ) => {
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'SetStateAction<"settings" | "jobs" | "dashboard" | "referrals" | "earnings">'.
    setSelectedProduct(selectedKey);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly dashboard: "/dashboard"; readonly referrals: "/referrals"; readonly jobs: "/jobs"; readonly earnings: "/earnings"; readonly settings: "/settings"; }'.
    router.push(routeToProduct[selectedKey]);
  };

  React.useEffect(() => {
    // @ts-expect-error - TS2345 - Argument of type '"settings" | "jobs" | "dashboard" | "referrals" | "earnings" | undefined' is not assignable to parameter of type 'SetStateAction<"settings" | "jobs" | "dashboard" | "referrals" | "earnings">'.
    setSelectedProduct(defaultSelecttab);
  }, [router.location.pathname]);

  React.useEffect(() => {
    dispatch(getAllowedAgency());
  }, []);

  return (
    <div className={styles.content}>
      <div className={css.relativeContainer}>
        <div className={css.container}>
          <div className={css.flexColumn}>
            <div className={css.senseLogo}>
              <SenseLogo
                onClick={() => {
                  setSelectedProduct(PRODUCT_LISTS[0].product);
                  router.push('/');
                }}
              />
            </div>
            <div className={css.sideNavLinks}>
              {PRODUCT_LISTS.map(({product}) => {
                const title = getFormattedText(product);
                return (
                  <SideMenuLink
                    onChange={handleOnChange}
                    customTitle={t(makeKey(title), title)}
                    selectedValue={selectedProduct}
                    key={product}
                    pageNameKey={product}
                  />
                );
              })}
            </div>
          </div>
          <div className={css.stickyBottom}>
            <AccountBar />
          </div>
        </div>
      </div>
      <div className={styles.child}>{children}</div>
      {router.location.pathname.includes('setup') && <SetupProfile />}
    </div>
  );
};

export default SideNav;
